module.exports = {
    fr: {
        title: "Déplacez-vous avec Davoyage, votre chauffeur VTC à Lyon.",
        description:"Davoyage Chauffeur Privé est une entreprise de location de voitures avec chauffeur basée à Lyon, en France. Réservation en ligne ou par téléphone 24h/24 et 7j/7.",
        canonical: "/",
        hero: {
            title: "Chauffeur privé à Lyon, pour chaque occasion.",
            subtitle: "Affaires, aéroport, mariages, événements, montagne : la même exigence de ponctualité et de discrétion, à chaque trajet.",
            cta: "Demander un devis",
            phone: "06 60 26 53 36",
            caption: "Chauffeur privé VTC à Lyon"
        },
        trust: [
            {label: "★ 5,0/5", sub: "2 avis Google", url: "https://share.google/804fLtpPyjob9xix6"},
            {label: "Atout France", sub: "EVTC069140133", url: "/blog/atout-france"},
            {label: "FFEVTC", url: "/blog/federation-francaise-des-exploitants-de-voiture-de-transport-avec-chauffeur"},
            {label: "Only Lyon", url: "/blog/only-lyon"}
        ],
        destinationsLabel: "Destinations",
        destinationsTitle: "Où que vous alliez depuis Lyon, le même chauffeur vous accompagne.",
        destinations: [
            "Aéroport Lyon-Saint-Exupéry",
            "Paris",
            "Genève",
            "Annecy",
            "Courchevel",
            "Val d'Isère",
            "Val Thorens",
            "Méribel",
            "Les Arcs",
            "Alpe d'Huez",
            "Megève",
            "Route des Vins de Bourgogne",
            "Grenoble",
            "Chambéry",
            "…"
        ],
        closing: {
            title: "Votre prochain trajet mérite ce soin.",
            cta: "Demander un devis",
            phone: "06 60 26 53 36"
        },
        alternates: [
            {href: "/",hreflang: "fr"},
            {href: "/en/",hreflang: "en"},
            {href: "/ru/",hreflang: "ru"}
        ]
    },
    en: {
        title: "Ride with Davoyage, your private driver in France.",
        description:"Davoyage Private Driver is a car rental with driver company based in Lyon, France.",
        canonical: "/en/",
        hero: {
            title: "Private driver in Lyon, for every occasion.",
            subtitle: "Business, airport, weddings, events, mountain transfers: the same punctuality and discretion, every trip.",
            cta: "Request a quote",
            phone: "06 60 26 53 36",
            caption: "Private chauffeur VTC in Lyon"
        },
        trust: [
            {label: "★ 5.0/5", sub: "2 Google reviews", url: "https://share.google/804fLtpPyjob9xix6"},
            {label: "Atout France", sub: "EVTC069140133", url: "/en/blog/atout-france"},
            {label: "FFEVTC", url: "/en/blog/discover-the-french-federation-of-private-passenger-transport-companies-ffevtc"},
            {label: "Only Lyon", url: "/en/blog/only-lyon"}
        ],
        destinationsLabel: "Destinations",
        destinationsTitle: "From Lyon, with the same driver all the way.",
        destinations: [
            "Lyon-Saint-Exupéry Airport",
            "Paris",
            "Geneva",
            "Annecy",
            "Courchevel",
            "Val d'Isère",
            "Val Thorens",
            "Méribel",
            "Les Arcs",
            "Alpe d'Huez",
            "Megève",
            "Burgundy Wine Route",
            "Grenoble",
            "Chambéry",
            "…"
        ],
        closing: {
            title: "Your next trip deserves this much care.",
            cta: "Request a quote",
            phone: "06 60 26 53 36"
        },
        alternates: [
            {href: "/",hreflang: "fr"},
            {href: "/en/",hreflang: "en"},
            {href: "/ru/",hreflang: "ru"}
        ]
    },
    ru: {
        title: "Поездка с Davoyage, вашим личным водителем во Франции.",
        description:"Davoyage Private Driver - это прокат автомобилей с компанией-водителем в Лионе, Франция.",
        canonical: "/ru/",
        hero: {
            title: "Личный водитель на любой случай, в Лионе и за его пределами.",
            subtitle: "Деловые поездки, трансферы из аэропорта, свадьбы, мероприятия или поездки в Альпы — всегда с одинаковой деликатностью и вниманием.",
            cta: "Запросить расчёт",
            phone: "06 60 26 53 36",
            caption: "Личный водитель VTC в Лионе"
        },
        trust: [
            {label: "★ 5.0/5", sub: "2 отзыва Google", url: "https://share.google/804fLtpPyjob9xix6"},
            {label: "Atout France", sub: "EVTC069140133", url: "/ru/blog/atout-france"},
            {label: "FFEVTC", url: "/ru/blog/frantsuzskaya-federatsiya-perevozchikov-naemnykh-transportnykh-sredstv-ffevtc"},
            {label: "Only Lyon", url: "/ru/blog/only-lyon"}
        ],
        destinationsLabel: "Направления",
        destinationsTitle: "Из Лиона, с одним и тем же водителем.",
        destinations: [
            "Аэропорт Лион-Сент-Экзюпери",
            "Париж",
            "Женева",
            "Анси",
            "Куршевель",
            "Валь-д'Изер",
            "Валь-Торанс",
            "Мерибель",
            "Лез-Арк",
            "Альп-д'Юэз",
            "Межев",
            "Винная дорога Бургундии",
            "Гренобль",
            "Шамбери",
            "…"
        ],
        closing: {
            title: "Ваша следующая поездка заслуживает такого внимания.",
            cta: "Запросить расчёт",
            phone: "06 60 26 53 36"
        },
        alternates: [
            {href: "/",hreflang: "fr"},
            {href: "/en/",hreflang: "en"},
            {href: "/ru/",hreflang: "ru"}
        ]
    }
};